/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  PlanSortInput,
  useGetPlansQuery,
  PlansFilterInput,
  useGetPlansBasicQuery,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort?: PlanSortInput;
  filter?: PlansFilterInput;
  basic?: boolean;
};

export function useGetPlans({ page, limit, sort, filter, basic }: Props) {
  const variables = { page: Number(page), limit: Number(limit), sort, filter };
  const basicResult = useGetPlansBasicQuery({
    variables,
    skip: !basic,
    notifyOnNetworkStatusChange: true,
  });
  const fullResult = useGetPlansQuery({
    variables,
    skip: !!basic,
  });
  const queryResult = basic ? basicResult : fullResult;
  const { data, previousData, loading, error, refetch } = queryResult;
  const count = loading
    ? previousData?.plans?.pageInfo?.count ?? data?.plans?.pageInfo?.count ?? 0
    : data?.plans?.pageInfo?.count ?? 0;

  return {
    data: data?.plans.result ?? [],
    loading,
    error,
    count,
    refetch,
  } as const;
}
